import type { OnceUIDataStyleConfig, OnceUIStyleConfig } from "@once-ui-system/core";

// Minimal SaaS look: neutral gray surfaces, high-contrast primary buttons, blue only for accents.
export const style: OnceUIStyleConfig = {
  // "dark" or "light" here locks the theme and the top-bar switch stops working.
  // Keep "system" and pick what a first visit sees with defaultTheme.
  theme: "system",
  defaultTheme: "system",
  neutral: "gray",
  brand: "blue",
  accent: "indigo",
  solid: "contrast",
  solidStyle: "flat",
  border: "conservative",
  surface: "filled",
  transition: "micro",
  scaling: "100",
};

export const dataStyle: OnceUIDataStyleConfig = {
  variant: "flat", // flat | gradient | outline
  mode: "categorical", // categorical | divergent | sequential
  height: 24,
  axis: { stroke: "var(--neutral-alpha-weak)" },
  tick: { fill: "var(--neutral-on-background-weak)", fontSize: 11, line: false },
};
